<div class="view-container">
  <abc-grid
    [dataSource]="categoryViewDefinition?.dataSource"
    [columns]="categoryViewDefinition?.columnInfos"
    [syncLookupFilterValues]="false"
    [headerFilter]="{ visible: false }"
    [showBorders]="false"
    [setupDefaultLayoutOnInitialization]="true"
    [editing]="{ mode: 'cell', allowUpdating: editCellEnabled }"
    [height]="'calc(100% - 55px)'"
  ></abc-grid>
  <div class="footer-container">
    <div class="actions-container">
      @for (button of actionButtons; track button) {
        <abc-button width="60" [text]="button.caption" (onClick)="button.action()"></abc-button
          >
        }
      </div>
    </div>
  </div>
